import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const TermsOfService = () => {
  const { currentUser } = useApp();
  const homeLink = currentUser ? '/events' : '/login';

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
      <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <Link to={homeLink} style={{
          color: '#007bff',
          textDecoration: 'none',
          fontSize: '1rem',
          padding: '0.5rem 1rem',
          border: '1px solid #007bff',
          borderRadius: '4px',
          display: 'inline-block'
        }}>← Back to {currentUser ? 'Events' : 'Login'}</Link>
      </div>

      <h1 style={{ textAlign: 'center', marginBottom: '0.5rem', color: '#333' }}>Terms of Service</h1>
      <p style={{ textAlign: 'center', color: '#6c757d', marginBottom: '2rem' }}>Last updated: {new Date().getFullYear()}</p>

      <div style={{ display: 'grid', gap: '1.5rem' }}>
        <section>
          <h2 style={{ color: '#007bff', borderBottom: '2px solid #007bff', paddingBottom: '0.5rem' }}>Using the Platform</h2>
          <p>
            By creating an account and using Real Air Scheduling, you agree to provide accurate information and to
            use the platform only for lawful flight scheduling, training, and related aviation management purposes.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#28a745', borderBottom: '2px solid #28a745', paddingBottom: '0.5rem' }}>Accounts & Organizations</h2>
          <p>
            You are responsible for the accuracy of information you enter and for keeping your login credentials
            secure. Organization administrators are responsible for the users and data within their organization.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: '0.5rem' }}>Scheduling & Training Records</h2>
          <p>
            Reservation, aircraft, and training records are provided as a scheduling and record-keeping aid. Final
            responsibility for flight safety, currency, and regulatory compliance remains with pilots, instructors,
            and organizations, not with the platform provider.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#6f42c1', borderBottom: '2px solid #6f42c1', paddingBottom: '0.5rem' }}>Payments</h2>
          <p>
            Any payments made through the platform are processed by third-party payment providers and are subject
            to their terms in addition to these terms.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#fd7e14', borderBottom: '2px solid #fd7e14', paddingBottom: '0.5rem' }}>Availability & Changes</h2>
          <p>
            We may update, modify, or discontinue features of the platform at any time, and we may update these
            terms from time to time. Continued use of the platform means you accept the current terms.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#007bff', borderBottom: '2px solid #007bff', paddingBottom: '0.5rem' }}>Contact Us</h2>
          <p>
            Questions about these terms can be sent through our <Link to="/contact" style={{ color: '#007bff' }}>Contact page</Link>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
